import type {
	Locale,
	TranslationNode,
	TranslationTree,
} from "@llmgateway/i18n";

export type UiMessageModule = Partial<Record<Locale, TranslationTree>>;

export function mergeUiMessages(
	...modules: UiMessageModule[]
): UiMessageModule {
	return modules.reduce<UiMessageModule>(
		(merged, module) => ({
			en: mergeTree(merged.en, module.en),
			"zh-CN": mergeTree(merged["zh-CN"], module["zh-CN"]),
		}),
		{},
	);
}

function mergeTree(
	base: TranslationTree | undefined,
	override: TranslationTree | undefined,
): TranslationTree {
	if (!base) {
		return override ?? {};
	}
	if (!override) {
		return base;
	}

	const merged: TranslationTree = { ...base };
	for (const [key, value] of Object.entries(override)) {
		const currentValue = merged[key];
		merged[key] =
			isTree(currentValue) && isTree(value)
				? mergeTree(currentValue, value)
				: value;
	}
	return merged;
}

function isTree(value: TranslationNode | undefined): value is TranslationTree {
	return typeof value === "object" && value !== null;
}
